import logo from '../../assets/images/zettablock-logo.svg';

export default function Logo({ className }: { className?: string }) {
  return <img src={logo} alt='ZettaBlock logo' className={className} />;
}
